/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SspMediaApprovalAPI {

  /**
   * Method that creates a new ssp media approval
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiSspMediaApproval(
    requestBody: {
      id?: number;
      ssp_id: number;
      ssp_publisher_id?: number | null;
      dealid?: string | null;
      media_id: number;
      advertiser_name: string;
      advertiser_domain?: string | null;
      category: string;
      language: string;
      seatid: string;
      approval_requirement_id: number;
      approval_status_id?: 'approved' | 'pending' | 'refused';
      created_at?: string | null;
      submitted_at?: string | null;
    },
  ): CancelablePromise<{
    id: number;
    ssp_id: number;
    ssp_publisher_id: number | null;
    dealid: string | null;
    media_id: number;
    advertiser_name: string;
    advertiser_domain: string | null;
    category: string;
    language: string;
    seatid: string;
    approval_requirement_id: number;
    approval_status_id: 'approved' | 'pending' | 'refused';
    created_at: string | null;
    submitted_at: string | null;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/ssp_media_approval',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a particular ssp media approval
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiSspMediaApproval(
    requestBody: {
      id: number;
      ssp_id?: number;
      ssp_publisher_id?: number | null;
      dealid?: string | null;
      media_id?: number;
      advertiser_name?: string;
      advertiser_domain?: string | null;
      category?: string;
      language?: string;
      seatid?: string;
      approval_requirement_id?: number;
      approval_status_id?: 'approved' | 'pending' | 'refused';
      created_at?: string | null;
      submitted_at?: string | null;
    },
  ): CancelablePromise<{
    id: number;
    ssp_id: number;
    ssp_publisher_id: number | null;
    dealid: string | null;
    media_id: number;
    advertiser_name: string;
    advertiser_domain: string | null;
    category: string;
    language: string;
    seatid: string;
    approval_requirement_id: number;
    approval_status_id: 'approved' | 'pending' | 'refused';
    created_at: string | null;
    submitted_at: string | null;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/ssp_media_approval',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns a particular ssp media approval
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiSspMediaApproval(
    id: number,
  ): CancelablePromise<{
    id: number;
    ssp_id: number;
    ssp_publisher_id: number | null;
    dealid: string | null;
    media_id: number;
    advertiser_name: string;
    advertiser_domain: string | null;
    category: string;
    language: string;
    seatid: string;
    approval_requirement_id: number;
    approval_status_id: 'approved' | 'pending' | 'refused';
    created_at: string | null;
    submitted_at: string | null;
  } | null> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/ssp_media_approval/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns a list of ssp media approval
   * @param offset
   * @param limit
   * @param orderby
   * @param comparator
   * @param mediaId
   * @param sspId
   * @param sspPublisherId
   * @param approvalStatusId
   * @param advertiserName
   * @param category
   * @param language
   * @param createdAt
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiSspMediaApprovalList(
    offset?: number,
    limit?: number,
    orderby?: Array<string>,
    comparator?: Array<string>,
    mediaId?: Array<number>,
    sspId?: Array<number>,
    sspPublisherId?: Array<number>,
    approvalStatusId?: Array<'approved' | 'pending' | 'refused'>,
    advertiserName?: string,
    category?: string,
    language?: Array<'de' | 'el' | 'en' | 'es' | 'fr' | 'it' | 'ja' | 'pt' | 'zh'>,
    createdAt?: Array<string | null>,
  ): CancelablePromise<Array<{
    id: number;
    ssp_id: number;
    ssp_publisher_id: number | null;
    dealid: string | null;
    media_id: number;
    advertiser_name: string;
    advertiser_domain: string | null;
    category: string;
    language: string;
    seatid: string;
    approval_requirement_id: number;
    approval_status_id: 'approved' | 'pending' | 'refused';
    created_at: string | null;
    submitted_at: string | null;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/ssp_media_approval/list',
      query: {
        'offset': offset,
        'limit': limit,
        'orderby': orderby,
        'comparator': comparator,
        'media_id': mediaId,
        'ssp_id': sspId,
        'ssp_publisher_id': sspPublisherId,
        'approval_status_id': approvalStatusId,
        'advertiser_name': advertiserName,
        'category': category,
        'language': language,
        'created_at': createdAt,
      },
    });
  }

  /**
   * Method that returns a list of ssp media approval
   * @param offset
   * @param limit
   * @param orderby
   * @param comparator
   * @param mediaId
   * @param sspId
   * @param sspPublisherId
   * @param approvalStatusId
   * @param advertiserName
   * @param category
   * @param language
   * @param createdAt
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiSspMediaApprovalMediaList(
    offset?: number,
    limit?: number,
    orderby?: Array<string>,
    comparator?: Array<string>,
    mediaId?: Array<number>,
    sspId?: Array<number>,
    sspPublisherId?: Array<number>,
    approvalStatusId?: Array<'approved' | 'pending' | 'refused'>,
    advertiserName?: string,
    category?: string,
    language?: Array<'de' | 'el' | 'en' | 'es' | 'fr' | 'it' | 'ja' | 'pt' | 'zh'>,
    createdAt?: Array<string | null>,
  ): CancelablePromise<Array<{
    media_id: number;
    media: {
      id: number;
      name: string | null;
      content_type_id: number;
      media_type_id: number;
      format_id: number | null;
      mime_type: string | null;
      preview_image_path: string | null;
      media: string | null;
      headline: string | null;
      display_url: string | null;
      duration: number | null;
      created_at: string | null;
      is_replacement: boolean;
      is_deleted: boolean;
      is_secure: boolean;
      owner_id: number | null;
      agency_id: number | null;
      platform_id: number;
      filesize: number | null;
      height: number | null;
      width: number | null;
      videooh_encoding_status: 'encoding' | 'error' | 'done' | null;
      videooh_media: string | null;
      is_draft: boolean;
      media_video?: Array<{
        id: number;
        media_id: number;
        mime_type: string;
        file_path: string;
        duration: number | null;
        width: number;
        height: number;
        bitrate: number | null;
        filesize: number | null;
        created_at: string;
      }>;
    };
    ssp_approval: Array<{
      id: number;
      ssp_id: number;
      ssp_publisher_id: number | null;
      dealid: string | null;
      advertiser_name: string;
      advertiser_domain: string | null;
      category: string;
      language: string;
      seatid: string;
      approval_requirement_id: number;
      approval_status_id: 'approved' | 'pending' | 'refused';
      created_at: string | null;
      submitted_at: string | null;
    }>;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/ssp_media_approval/media_list',
      query: {
        'offset': offset,
        'limit': limit,
        'orderby': orderby,
        'comparator': comparator,
        'media_id': mediaId,
        'ssp_id': sspId,
        'ssp_publisher_id': sspPublisherId,
        'approval_status_id': approvalStatusId,
        'advertiser_name': advertiserName,
        'category': category,
        'language': language,
        'created_at': createdAt,
      },
    });
  }

  /**
   * Method that returns a list of ssp media approval
   * @param offset
   * @param limit
   * @param orderby
   * @param comparator
   * @param mediaId
   * @param sspId
   * @param sspPublisherId
   * @param approvalStatusId
   * @param advertiserName
   * @param category
   * @param language
   * @param createdAt
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiSspMediaApprovalCount(
    offset?: number,
    limit?: number,
    orderby?: Array<string>,
    comparator?: Array<string>,
    mediaId?: Array<number>,
    sspId?: Array<number>,
    sspPublisherId?: Array<number>,
    approvalStatusId?: Array<'approved' | 'pending' | 'refused'>,
    advertiserName?: string,
    category?: string,
    language?: Array<'de' | 'el' | 'en' | 'es' | 'fr' | 'it' | 'ja' | 'pt' | 'zh'>,
    createdAt?: Array<string | null>,
  ): CancelablePromise<{
    count: number;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/ssp_media_approval/count',
      query: {
        'offset': offset,
        'limit': limit,
        'orderby': orderby,
        'comparator': comparator,
        'media_id': mediaId,
        'ssp_id': sspId,
        'ssp_publisher_id': sspPublisherId,
        'approval_status_id': approvalStatusId,
        'advertiser_name': advertiserName,
        'category': category,
        'language': language,
        'created_at': createdAt,
      },
    });
  }

}
